module.exports = __webpack_public_path__ + "img/1.cd897e94.svg";